module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-1-d953e4cdb5ef16ac22cafe8ca8932551.jpg";